import { Navigate } from "react-router";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../data";
import { useStaffWorkspace, type StaffWorkspace } from "../../app/session";
import { ErrorState, Loading } from "../../components/States";
import { t } from "../../lib/sprache";

/**
 * Creator-Konto (0178): Die Person ist zugleich ihr einziger Creator (talents.is_self). Formulare der Agentur-Seiten füllen
 * den Creator damit selbst aus und blenden die Auswahl aus; „Mein Profil“ führt auf die Profilseite dieses Eintrags.
 */
export function useSelfTalent(ws: Pick<StaffWorkspace, "org" | "isCreator">) {
  return useQuery({
    queryKey: ["self_talent", ws.org.org_id],
    enabled: !!ws.isCreator,
    staleTime: 300_000,
    queryFn: async () => (await api.select<{ id: string }>("talents", { columns: "id", filters: [["org_id", "eq", ws.org.org_id], ["is_self", "is", true]] }))[0]?.id ?? null,
  });
}

/** /agentur/ich: zum eigenen Profil (im Agentur-Konto zur Creator-Liste) */
export function MeinProfil() {
  const ws = useStaffWorkspace();
  const self = useSelfTalent(ws);
  if (!ws.isCreator) return <Navigate to="/agentur/creator" replace />;
  if (self.isPending) return <Loading />;
  if (self.error || !self.data) return <ErrorState error={self.error ?? new Error(t("Dein Profil wurde nicht gefunden.", "Your profile was not found."))} />;
  return <Navigate to={`/agentur/creator/${self.data}`} replace />;
}
